import CryptoJS from "crypto-js";
import { WiMuleSQL } from "../../../services/WiMuleSQL";

const SECRET_KEY = import.meta.env.VITE_ENTRA_EMAIL_KEY;

// Ensure the key is exactly 32 bytes (256 bits)
function getAesKey(secret) {
  return CryptoJS.enc.Utf8.parse(secret.substring(0, 32)); // Ensure 32 bytes
}

function encryptEmail(email) {
  const key = getAesKey(SECRET_KEY);
  const encrypted = CryptoJS.AES.encrypt(email, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  // Convert to standard Base64 (avoid URL-safe issues)
  const standardBase64 = encrypted
    .replace(/-/g, "+") // Replace URL-safe chars
    .replace(/_/g, "/"); // Replace URL-safe chars

  return standardBase64;
}

export async function fetchUserData(email) {
  const encryptedEmail = encryptEmail(email);
  try {
    console.log("Encrypted Email", encryptedEmail);
    const response = await fetch(`${WiMuleSQL}/api/Auth/GetUserDataEntra`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedEmail),
    });

    if (!response.ok) {
      throw new Error(
        `HTTP Error: ${response.status} - ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw new Error("Failed to fetch user data");
  }
}
